var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgModalRed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEE4E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FEF3F2",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 24.5V28.5M28 32.5H28.01M38 28.5C38 34.0228 33.5228 38.5 28 38.5C22.4772 38.5 18 34.0228 18 28.5C18 22.9772 22.4772 18.5 28 18.5C33.5228 18.5 38 22.9772 38 28.5Z",
    stroke: "#D92D20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgModalRed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/modalRed.4222ce5ac3c1569eb3fd895de327a244.svg";